import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChart4"><Path d="M16.3398 21.001V3.00098H21.0098V21.001H16.3398Z" fill="currentColor"/><Path d="M9.66992 8.50098V21.001H14.3399V8.50098H9.66992Z" fill="currentColor"/><Path d="M3 14.001V21.001H7.67V14.001H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart4;
